import type { EventPickupRequest, PickupRequestStatus } from '../types';

export type PickupSort = 'newest' | 'oldest';

export interface PickupListFilters {
  status?: string | null;
  q?: string | null;
}

const STATUSES: readonly PickupRequestStatus[] = ['new', 'scheduled', 'picked_up', 'cancelled'];

export function isPickupRequestStatus(value: string | null | undefined): value is PickupRequestStatus {
  return value != null && (STATUSES as readonly string[]).includes(value);
}

function phoneQueryDigits(query: string): string | null {
  const compact = query.replace(/[\s()-]/g, '');
  if (!/^\+?\d{4,}$/.test(compact)) return null;
  return compact.replace(/\D/g, '');
}

export function filterPickupRequests(rows: EventPickupRequest[], filters: PickupListFilters): EventPickupRequest[] {
  const q = filters.q?.trim().toLowerCase();
  const qDigits = q ? phoneQueryDigits(q) : null;
  return rows.filter((row) => {
    if (filters.status && row.status !== filters.status) return false;
    if (!q) return true;
    const hay = [row.name, row.phone, row.address].join(' ').toLowerCase();
    const phoneDigits = row.phone.replace(/\D/g, '');
    const matchesText = hay.includes(q);
    const matchesPhone = qDigits != null && phoneDigits.includes(qDigits);
    return matchesText || matchesPhone;
  });
}

export function parsePickupSort(value: string | null | undefined): PickupSort | null {
  if (value === 'newest' || value === 'oldest') return value;
  return null;
}

/** Default is newest when the caller does not pass a sort. */
export function sortPickupRequests(rows: EventPickupRequest[], sort: PickupSort | null | undefined): EventPickupRequest[] {
  const direction = sort === 'oldest' ? 'oldest' : 'newest';
  return [...rows].sort((a, b) => {
    const byTime = a.createdAt < b.createdAt ? -1 : a.createdAt > b.createdAt ? 1 : 0;
    const cmp = byTime !== 0 ? byTime : a.id < b.id ? -1 : a.id > b.id ? 1 : 0;
    return direction === 'oldest' ? cmp : -cmp;
  });
}
